module.exports = __webpack_public_path__ + "img/quest_icon_0046_chat.cedef4d4.png";